<template>
  <v-app>
    <v-navigation-drawer
      app
      v-model="lateral"
      temporary
      v-if="zonaActual"
      width="219px"
    >
      <v-toolbar dense>
        <h3>{{zonaActual.DescTicketZona}}</h3>
        <v-spacer>

        </v-spacer>
        Aforo: {{zonaActual.AforoTotal}}
      </v-toolbar>
      <!-- <v-img
        width="219px"
        contain
        :src="imagenActiva"
      >

      </v-img> -->

      <img
        @mouseleave="desactivar()"
        :src="imagenActiva"
        width="219"
        height="294"
        alt="Planets"
        usemap="#mapabloques"
      >

      <map name="mapabloques">
        <area
          shape="poly"
          :coords="area.CoordMapa"
          @mouseenter="activar(area)"
          :target="area.Butacas=='S' ? '_blank' : '_self'"
          :href="area.Butacas=='S' ? `https://tickets.janto.es/hermandadesdecordoba/public/janto/main.php?Nivel=Detalle_1_Sesion&idSesion=0000000000023677&idZona=${zonaActual.idZona}&idBloque=${area.idBloque}${parametros}` : '#'"
          :alt="area.DescBloque"
          v-for="(area, a) in zonaActual.Bloque"
          :key="a+22"
          
        >

      </map>
      <v-card
        flat
        @mouseleave="desactivar()"
      >
        <v-list shaped>
          <!-- <v-subheader>{{zonaActual.DescTicketZona}}</v-subheader> -->
          <v-list-item-group
            v-model="activo"
            color="primary"
          >
            <v-list-item
              three-line
              v-for="(item, i) in zonaActual.Bloque"
              :key="i"
              :href="enlaceActivo"
              target="_blank"
              :disabled="item.Butacas=='N'"
            >

              <v-list-item-content  @mouseenter="activar(item)">
                <v-list-item-title v-text="item.DescBloque"></v-list-item-title>
                <v-list-item-subtitle>
                  Aforo: {{item.AforoTotal}}
                </v-list-item-subtitle>
                <v-list-item-subtitle>
                  Libres: {{item.Butacas=='S' ? 'Si' : 'No'}}
                </v-list-item-subtitle>

              </v-list-item-content>
              <v-list-item-icon>
                <v-icon
                  v-if="item.Butacas=='S'"
                  small
                >mdi-cart</v-icon>
                <v-icon
                  v-else
                  small
                >mdi-cart-off</v-icon>
              </v-list-item-icon>

            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-card>
      <!-- {{zonaActual.Bloque}} -->
    </v-navigation-drawer>
    <v-app-bar
      color="black"
      dark
      dense
      app
    >
      <v-spacer></v-spacer>

      <v-toolbar-title>
        <v-img
          src="https://tickets.janto.es/hermandadesdecordoba/public/static/web/img/logo.png"
          height="50px"
        ></v-img>
      </v-toolbar-title>

    </v-app-bar>

    <v-content>
      <router-view></router-view>
    </v-content>
  </v-app>
</template>

<script>
import gql from "graphql-tag";

export default {
  apollo: {
    getDetalleAforo() {
      return {
        query: gql`
          query DetalleAforo($Contexto: String!) {
            getDetalleAforo(Contexto: $Contexto) {
              IdSesion
              IdAforoMatriz
              Nivel {
                idNivel
                DescNivel
                DescTicketNivel
                ImagenMapa
                AforoTotal
                Area {
                  DescArea
                  ImagenMapa
                  AforoTotal
                  Zona {
                    idZona
                    DescTicketZona
                    ImagenMapa
                    CoordMapa
                    AforoTotal
                    Bloque {
                      Butacas
                      ButacasAforoMatriz
                      DescBloque
                      CoordMapa
                      ImagenMapa
                      idBloque
                      AforoTotal
                      MinPrecio
                      MaxPrecio
                    }
                  }
                }
              }
            }
          }
        `,
        variables: {
          Contexto: "Janto_FRESH"
        }
      };
    }
  },
  watch: {
    getDetalleAforo() { 
      const DetalleAforo = this.getDetalleAforo;
      console.log(this.$route)
      if (DetalleAforo.hasOwnProperty("Nivel")) {
        const zonas = DetalleAforo.Nivel[0].Area[0].Zona;
        this.$store.commit("zonas", zonas);
      }
    }
  },
  data() {
    return {
      urlBase:
        "https://tickets.janto.es/hermandadesdecordoba/public/static/aforos/",
      activo: null,
      bloqueActivo: {},
      bloques: false
    };
  },
  methods: {
    activar(bloque) {
      this.bloques = true;
      this.bloqueActivo = bloque;
      // console.log('mi bloque', bloque.DescBloque)
    },
    desactivar() {
      this.bloques = false;
      this.activo = false;
      this.bloqueActivo = {};
    }
  },
  computed: {
    parametros(){
      const leerRuta = this.$route.fullPath
      const parametros = leerRuta.length > 1 ? '&'+leerRuta.substr(2) : ''
      console.log(parametros)
      return parametros
    },
    lateral: {
      get() {
        return this.$store.state.lateral;
      },
      set(valor) {
        this.$store.commit("lateral", valor);
      }
    },
    zonaActual() {
      return this.$store.state.zonaActual;
    },
    imagenActiva() {
      // console.log("bloques", this.zonaActual);
      const raiz = "/MAG_CORDOBA/";
      const imagen = !this.bloques
        ? this.zonaActual.ImagenMapa
        : raiz + this.bloqueActivo.ImagenMapa;
      return this.urlBase + imagen;
    },
    enlaceActivo() {
      if (!this.bloqueActivo) {
        return;
      }
      const idBloque = this.bloqueActivo.idBloque;
      const idZona = this.zonaActual.idZona;
      const enlace = `https://tickets.janto.es/hermandadesdecordoba/public/janto/main.php?Nivel=Detalle_1_Sesion&idSesion=0000000000023677&idZona=${idZona}&idBloque=${idBloque}${this.parametros}`;
      return enlace;
    }
  }
};
</script>

